export default "__VITE_ASSET__30fd6b21__"